<script setup lang="ts">
const props = defineProps<{
  value: string
  itemKey: string
  percentage: string
  showPercentage: boolean
}>()
const { t } = useLocale()

const percentage = computed(() =>
  props.showPercentage && props.percentage
    ? `<span class="text-mcd-secondaryGrey">(${props.percentage} ${t(
        'productDetailStatic.nutritional.idr'
      )})</span>`
    : ''
)
</script>

<template>
  <div
    class="flex h-24 w-[8.5rem] flex-col items-center gap-1 rounded-lg p-4 tracking-[-0.15px] shadow-elevation-down"
  >
    <p class="w-full text-lg font-bold">{{ value }}</p>
    <div class="w-full text-xs *:inline">
      <p class="text-mcd-secondaryDarkGrey">
        {{ t(`productDetailStatic.nutritional.items.${itemKey}`) }}
      </p>
      <template v-if="percentage">
        &nbsp;
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="percentage"></p>
      </template>
    </div>
  </div>
</template>
